import {createTheme} from "@mui/material";

export const theme = createTheme({
    // https://dribbble.com/shots/26679062-Lunopay-Finance-App
    palette: {
        primary: {
            main: "#CED4DA",
        },
        background: {
            default: "#E8E8E8",
        },
    },
    typography: {
        fontFamily: [
            'Rubik',
            'sans-serif',
        ].join(','),
    },
    components: {
        MuiButton: {
            defaultProps: {
                disableElevation: true,
            },
            styleOverrides: {
                root: {
                    border: "1.5px solid black",
                    // borderRadius: 24,
                },
            },
        },
    }
});